import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  initAnalytics,
  resolvePageType,
  trackPageView,
} from "@/features/analytics";

/**
 * Initialises analytics once and emits a `page_view` on every route change.
 * Rendered inside the Router so it can observe navigation.
 */
export const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const miniAppUuid = params.get("miniAppUuid") || undefined;

    trackPageView({
      page_type: resolvePageType(location.pathname),
      title_page: typeof document !== "undefined" ? document.title : undefined,
      referrer_page: previousPathRef.current ?? undefined,
      mini_app_uuid: miniAppUuid,
    });

    previousPathRef.current = location.pathname + location.search;
  }, [location.pathname, location.search]);

  return <>{children}</>;
};
